<template>
  <div class="main" ref="main" :class="cursor">
    <div v-if="captionActive" class="category-title">
      {{ categories[categoryIndex] }}
    </div>
    <projects
      v-for="(category, index) in categories"
      :key="category"
      ref="projects"
      :projects="filter(projects, category)"
      :active="index === categoryIndex"
      :id="category"
    />
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
const Projects = () =>
  import(/* webpackChunkName: "Projects" */ "@/components/Projects.vue");
import { mapState } from "vuex";
export default {
  name: "home",
  components: {
    Projects
  },
  data() {
    return {
      categories: ["paintings", "drawings", "other", "editorial", "curatorial"],
      categoryIndex: 0,
      cursor: "default",
      loadScroll: false,
      captionActive: true
    };
  },
  mounted() {
    if (!isMobile) {
      this.$refs.main.addEventListener("mousemove", this.move);
      this.$refs.main.addEventListener("click", this.click);
    }
    this.$refs.main.addEventListener("scroll", this.scroll);
    this.$root.$on("goTo", this.goToCategory);
    this.$root.$on("toggleCaption", this.toggleCaption);
  },
  updated() {
    if (
      this.$route.name !== "home" ||
      this.$route.name !== "list" ||
      this.$route.name !== "info"
    ) {
      if (!this.loadScroll) {
        this.goTo(this.$route.name);
      }
    }
  },
  computed: mapState(["projects"]),
  methods: {
    toggleCaption() {
      this.captionActive = !this.captionActive;
    },
    goTo(category) {
      let newIndex = this.categories.indexOf(category);
      let newPos = newIndex * window.innerWidth;
      if (this.projects.length > 0) {
        this.$refs.main.scroll({
          left: newPos,
          behavior: "auto"
        });
        this.loadScroll = true;
      }
    },
    filter(array, filter) {
      return array.filter(project => project.category === filter);
    },
    goToCategory(file, category) {
      let newIndex = this.categories.indexOf(category);
      let newPos = this.$refs.projects[newIndex].$el.offsetLeft;
      this.$refs.main.scroll({
        left: newPos,
        behavior: "auto"
      });
    },
    scroll() {
      var scrollPos = this.$refs.main.scrollLeft;
      for (var i = 0; i < this.$refs.projects.length; i++) {
        var left = this.$refs.projects[i].$el.offsetLeft;
        var right = left + window.innerWidth;
        if (scrollPos >= left && scrollPos < right) {
          this.categoryIndex = i;
          this.$router
            .replace({
              name: this.categories[i]
            })
            .catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          this.$root.$emit("slideChanged");
        }
      }
    },
    move(event) {
      var leftZone = window.innerWidth / 3;
      var rightZone = window.innerWidth - leftZone;
      if (event.clientX > 0 && event.clientX < leftZone) {
        this.cursor = "left";
      } else if (
        event.clientX > rightZone &&
        event.clientY < window.innerWidth
      ) {
        this.cursor = "right";
      } else {
        this.cursor = "";
      }
    },
    click(event) {
      var leftZone = window.innerWidth / 3;
      var rightZone = window.innerWidth - leftZone;
      if (event.clientX > 0 && event.clientX < leftZone) {
        if (this.categoryIndex !== 0) {
          var back = this.$refs.main.scrollLeft - window.innerWidth;
          this.$refs.main.scroll({
            left: back,
            behavior: "smooth"
          });
        } else {
          var end = this.$refs.projects[this.$refs.projects.length - 1].$el;
          this.$refs.main.scroll({
            left: end.offsetLeft,
            behavior: "smooth"
          });
        }
        this.$root.$emit("slideChanged");
      }
      if (event.clientX > rightZone && event.clientX < window.innerWidth) {
        if (this.categoryIndex !== this.$refs.projects.length - 1) {
          var next = this.$refs.main.scrollLeft + window.innerWidth;
          this.$refs.main.scroll({
            left: next,
            behavior: "smooth"
          });
        } else {
          var beginning = this.$refs.projects[0].$el;
          this.$refs.main.scroll({
            left: beginning.offsetLeft,
            behavior: "smooth"
          });
        }
        this.$root.$emit("slideChanged");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  scroll-snap-type: x mandatory;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  display: flex;
  .category-title {
    position: fixed;
    top: var(--lh);
    left: 0;
    padding: 0.25rem;
    text-transform: capitalize;
    z-index: 1;
  }
  &.loading {
    align-items: center;
    justify-content: center;
  }
}
.main,
section {
  scrollbar-width: none;
  -ms-overflow-style: none;
  // scroll-behavior: smooth;
}
.main::-webkit-scrollbar,
section::-webkit-scrollbar {
  display: none;
}
</style>
